import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/SettingsLabels';

import { Channel } from '../../../model/skill';
import { AliceSkillFormSettingsField, SmartHomeFormSettingsField, ThereminvoxFormSettingsField } from '../../../types';

const t = i18n(keyset);

const installableAppErrorsMessage = {
    activationPhrase: t('activation-phrase'),
    activationPhrases: t('activation-phrases'),
    name: t('app-name'),
    developerName: t('developer-name'),
    email: t('email'),
    logoId: t('banner'),
    pacakgeName: t('package-name'),
    noteForModerator: t('note-for-moderator'),
    category: t('category'),
    description: t('description'),
    ageRestriction: t('age-restriction'),
    targetPlatforms: t('target-platforms'),
    versionNotes: t('version-notes'),
    licenseAgreement: t('license-agreement'),
    privacyAgreement: t('privacy-agreement'),
    screenshots: t('screenshots'),
};

export const labels = {
    [Channel.AliceSkill]: {
        name: t('name'),
        developerName: t('developer-name'),
        email: t('email'),
        brandVerificationWebsite: t('brand-verification-website'),
        logoId: t('logo'),
        hideInStore: t('hide-in-store'),

        uri: 'Webhook URL',
        functionId: t('function'),
        voice: t('voice'),
        category: t('category'),
        description: t('description'),
        noteForModerator: t('note-for-moderator'),

        activationPhrases: t('activation-phrases'),
        structuredExamples: t('examples'),
        yaCloudGrant: t('cloud'),
        exactSurfaces: t('exact-surfaces'),
        surfaceWhitelist: t('surfaces-whitelist'),
        surfaceBlacklist: t('surfaces-blacklist'),
        explicitContent: t('explicit-content'),
        requiredInterfaces: t('require-interfaces'),
        useStateStorage: t('state-storage'),
        skillAccess: t('skill-access'),
    } as Record<AliceSkillFormSettingsField, string>,
    [Channel.SmartHome]: {
        name: t('just-name'),
        developerName: t('developer-name'),
        email: t('email'),
        brandVerificationWebsite: t('brand-verification-website'),
        logoId: t('logo'),
        hideInStore: t('hide-in-store'),

        uri: 'Endpoint URL',
        functionId: t('function'),
        voice: t('voice'),
        category: t('category'),
        description: t('description'),
        noteForModerator: t('note-for-moderator'),

        secondaryTitle: t('subtitle'),
        androidDeepLink: t('android-deeplink'),
        iosDeepLink: t('ios-deeplink'),
        iosDeepLinkFallbackURL: t('ios-deeplink-fallback'),
        isTrustedSmartHomeSkill: t('trusted-skill'),
        skillAccess: t('skill-access'),
        selectedRegions: t('selected-regions'),
    } as Record<SmartHomeFormSettingsField, string>,
    [Channel.Thereminvox]: {
        hideInStore: t('hide-in-store'),
        name: t('just-name'),
    } as Record<ThereminvoxFormSettingsField, string>,
    [Channel.AutoApp]: installableAppErrorsMessage,
    [Channel.SmartScreenApp]: installableAppErrorsMessage,
    [Channel.TvApp]: installableAppErrorsMessage,
};

export const skillLabels = labels[Channel.AliceSkill];
export const smartHomeLabels = labels[Channel.SmartHome];
export const thereminvoxLabels = labels[Channel.Thereminvox];
export const installableAppLabels = { ...labels[Channel.SmartScreenApp], ...labels[Channel.TvApp] };
